// extracted by mini-css-extract-plugin
export var actionText = "_so-4";
export var container = "_so-0";
export var leftSection = "_so-1";
export var rightSection = "_so-2";
export var settingsButton = "_so-6";
export var settingsIcon = "_so-7";
export var shortcut = "_so-5";
export var shortcutGroup = "_so-3";